import type { LastActivityKind } from "@/api";

/**
 * The word under „Zuletzt" in the register (design §6.2): the server sends a
 * closed vocabulary, the sentence is the client's. `Record<…>` makes a new
 * kind a compile error here — the runtime fallback is for the deployed
 * bundle that meets a newer server first (the same reasoning as `stageOf`).
 */
const WORDS: Record<LastActivityKind, string> = {
  created: "Vorgang angelegt",
  status_changed: "Stadium geändert",
  plan_saved: "Stand gespeichert",
  calculated: "Kalkulation gerechnet",
  approved: "Kalkulation freigegeben",
  withdrawn: "Freigabe zurückgezogen",
  document_added: "Zeichnung abgelegt",
  mail_added: "Mail abgelegt",
  note_added: "Notiz geschrieben",
  file_added: "Datei abgelegt",
  customer_assigned: "Kunde zugeordnet",
  handover: "Übergabe",
  other: "bearbeitet",
};

export function activityWord(kind: LastActivityKind): string {
  return Object.hasOwn(WORDS, kind) ? WORDS[kind] : WORDS.other;
}
